export const alertMessage = { width: "100%" };
